module.exports = __webpack_public_path__ + "img/icone.1d586c2e.png";